// The import API uses zero-based indices; Excel labels start at A.
export function excelColumnLabel (index) {
    if (!Number.isInteger(index) || index < 0) return '';

    let position = index + 1;
    let label = '';
    while (position > 0) {
        position -= 1;
        label = String.fromCharCode(65 + position % 26) + label;
        position = Math.floor(position / 26);
    }
    return label;
}
